import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cam-tools",
  "use": "cam-tools-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"cam-tools\"><path d=\"M13 19.992v2h-2v-2zm4-2v2h-2v-2zm-8 0v2H7v-2zm4-2v2h-2v-2zm8 0v2h-2v-2zm-16 0v2H3v-2zm-2-8 8 4.58v1.42H3zm18 0v6h-8v-1.42zm-9.49-5.864a1 1 0 0 1 .98 0L20 6.342l-8 4.5-7.998-4.498z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol